export default "__VITE_ASSET__DxdPczP___"